import React from 'react';
import Grid from '../../../components/Grid';
import { useSelector } from 'react-redux';
import { SelectShowCloudAgents, selectCloudAgents, selectUserAgents } from 'store/Agents/selectors';
import TableContent from '../../../components/TableContent';
import { RUN_STATUS_LOG } from '../../Tabs/constants';

const RecordsRepresentation = ({ showGridView, selectedTab }) => {
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const userAgents = useSelector(selectUserAgents);
  const cloudAgents = useSelector(selectCloudAgents);

  if (showGridView && selectedTab !== RUN_STATUS_LOG) return <Grid agents={ showCloudAgents ? cloudAgents : userAgents } />;
  return <TableContent selectedTab={ selectedTab } />;
};

export default RecordsRepresentation;
